import React, { useEffect } from 'react';

const TradutorMapa = () => {
  useEffect(() => {
    const initTranslate = () => {
      if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'pt',
            includedLanguages: 'pt,en,es',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          'google_translate_element'
        );
      }
    };

    if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
      const script = document.createElement('script');
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = initTranslate;
    } else {
      // If script is already there, wait a brief moment or check availability
      // to avoid the "InlineLayout" undefined error during fast re-renders
      if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        initTranslate();
      } else {
        // Fallback if script exists but object isn't ready yet
        const interval = setInterval(() => {
          if (window.google && window.google.translate && window.google.translate.TranslateElement) {
            initTranslate();
            clearInterval(interval);
          }
        }, 100);
        return () => clearInterval(interval);
      }
    }

    const handleHashChange = () => {
      // Se o hash inserido for relacionado ao Google Translate (ex: #googtrans)
      // ou se você quiser remover qualquer hash vazio inserido pelo clique
      if (window.location.hash) {
        window.history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div>
      <div id="google_translate_element" style={{ marginBottom: '1rem' }}></div>
    </div>
  );
};

export default TradutorMapa;